// extracted by mini-css-extract-plugin
export default {"onsiteInfo":"InfoTooltip_onsiteInfo__zE4ty","onsiteInfoTooltiptext":"InfoTooltip_onsiteInfoTooltiptext__r5ca7"};